import {
  EnrollmentStatus,
  GcpBox,
  GcpEnrollmentStatus,
  GcpTypography,
  getDatetimeText,
} from '@back-office/ui';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { lowerCase } from 'lodash';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './UserDetail';

type EnrollmentDetailsProps = {
  enrollmentId: string;
  createdAt: string;
  status: string;
  reason: string | null;
};

const EnrollmentDetails: FC<EnrollmentDetailsProps> = (props) => {
  const { enrollmentId, createdAt, status, reason } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container>
      <Typography className={classes.header}>
        {t('recurring_payment_detail.enrollment_details')}
      </Typography>
      <TableContainer>
        <Table aria-label="User Detail">
          <TableBody>
            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.enrollment_confirmation_number')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} colSpan={3} width="75%">
                <Typography> {enrollmentId || '-'}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.enrollment_date')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} colSpan={3} width="75%">
                <Typography>
                  {createdAt ? getDatetimeText(createdAt, 'longDate') : '-'}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.enrollment_status')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <GcpBox alignItems="center" display="flex" gap={1}>
                  <GcpEnrollmentStatus
                    size={8}
                    status={lowerCase(status || '') as EnrollmentStatus}
                  />
                  <GcpTypography
                    paint="mineShaft"
                    transform="capitalize"
                    variant="body1"
                  >
                    {t(
                      `biller_enrollment_list.status.${lowerCase(status || '')}`
                    )}
                  </GcpTypography>
                </GcpBox>
              </TableCell>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.reject_cancel_reason')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <Typography> {reason || '-'}</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default EnrollmentDetails;
